import {MenuStrategy} from "../MenuStrategy";

export class EliminaAccountMenuStrategy extends MenuStrategy {
   constructor() {
    super('Elimina Account', 'Elimina Account', 'app-delete-account');
  }
}
